import { connect } from "react-redux";
import HardwareRmTickets from "./hardwareRmTicket";
import { bindActionCreators } from "redux";
import {fetchRmHardwareTicket, getRmHardwareTicketsFilterDropDown} from "services/redux/maintenance/hardwareRmTicket/action";
const mapStateToProps = (state) => ({
  rmHardwareTicket: state.hardwareRmTicketReducer.rmHardwareTicket,
  rmHardwareTicketFilter: state.hardwareRmTicketReducer.rmHardwareTicketFilter
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchRmHardwareTicket,
      getRmHardwareTicketsFilterDropDown
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(HardwareRmTickets);
